import {useQuery} from '@tanstack/react-query'
import {QueryCacheKeys} from '../../QueryKey'
import {getLeaderboardBannerDetail} from '../../../apis/banner/getLeaderboardBannerDetail'
import {getPromotionDetail} from '../../../apis/promotion/detail'

const useQueryPromotionDetail = id => {
    const {data, refetch, isLoading} = useQuery({
        enabled: !!id,
        queryKey: QueryCacheKeys.promotion.getPromotionDetail(id),
        queryFn: async () => {
            const {data} = await getPromotionDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
    })

    return {data: data, refetch, isLoading}
}

export default useQueryPromotionDetail
